import React from 'react';
import { Banner, Layout, Paragraph, ParagraphHeader } from '@axiom/ui';
import type { CandidateEngagementDetails } from '@axiom/validation';

import { EnvUtil } from '../../utils/env-util';

import { EngagementsViewInterviewDetails } from './EngagementsViewInterviewDetails';

export type EngagementsViewStateBannerInterviewingClientUnacceptedTalentAcceptedProps =
  {
    interview: CandidateEngagementDetails['interviews'][number];
    name?: string;
  };

export const EngagementsViewStateBannerInterviewingClientUnacceptedTalentAccepted: React.FC<
  EngagementsViewStateBannerInterviewingClientUnacceptedTalentAcceptedProps
> = ({
  interview,
  name = 'ENGAGEMENTS_VIEW_STATE_BANNER_INTERVIEWING_CLIENT_UNACCEPTED_TALENT_ACCEPTED',
}) => {
  return (
    <Banner name={name} type="critical" impact="high">
      <Layout direction="vertical" verticalGutter="24px">
        <ParagraphHeader name="INTERVIEWING_CLIENT_UNACCEPTED_TALENT_ACCEPTED_HEADER">
          Next Step: Client interview confirmation
        </ParagraphHeader>
        <Paragraph name="INTERVIEWING_CLIENT_UNACCEPTED_TALENT_ACCEPTED_MESSAGE_1">
          Looks like we've found a time that works for everyone. The client will
          receive a calendar invite and we'll update the interview details here
          if anything changes. Please plan to attend regardless of the client's
          calendar response.
        </Paragraph>
        <Paragraph name="INTERVIEWING_CLIENT_UNACCEPTED_TALENT_ACCEPTED_MESSAGE_2">
          Go ahead and start preparing for your interview using{' '}
          <a href={EnvUtil.interviewGuideUrl} rel="noreferrer" target="_blank">
            Axiom's Interview Preparation Guidelines
          </a>
          .
        </Paragraph>
        <EngagementsViewInterviewDetails
          interview={interview}
          name="ENGAGEMENT_VIEW_INTERVIEW_DETAILS"
        />
      </Layout>
    </Banner>
  );
};
